export const albumSignupKey = 'lloyds-email-signup-v1';
export const albumSignupDetailsKey = 'lloyds-email-signup-details-v1';
const contributorNameKey = 'lloyds-contributor-name-v1';
const changed = 'lloyds-email-signup-changed';
let sessionSignup = false;
let sessionDetails: string | null = null;
let sessionName = '';
let cachedDetailsText: string | null = null;
let cachedDetails: AlbumSignupDetails | null = null;

export type AlbumSignupDetails = { name: string; email: string; canEdit: boolean };

export function getAlbumSignupDetails(): AlbumSignupDetails | null {
  let raw = sessionDetails;
  if (raw === null) {
    try { raw = localStorage.getItem(albumSignupDetailsKey); } catch { /* Use session details. */ }
  }
  if (raw === cachedDetailsText) return cachedDetails;
  cachedDetailsText = raw;
  cachedDetails = null;
  try {
    const value: unknown = JSON.parse(raw ?? 'null');
    if (value && typeof value === 'object' && 'name' in value && 'email' in value && 'canEdit' in value &&
      typeof value.name === 'string' && typeof value.email === 'string' && typeof value.canEdit === 'boolean')
      cachedDetails = { name: value.name, email: value.email, canEdit: value.canEdit };
  } catch { /* Older signups have no saved address. */ }
  return cachedDetails;
}

export function getContributorName() {
  try { return sessionStorage.getItem(contributorNameKey) || sessionName; } catch { return sessionName; }
}

export function rememberContributorName(name: string) {
  sessionName = name.trim().slice(0, 80);
  try { sessionStorage.setItem(contributorNameKey, sessionName); } catch { /* Keep it in this session. */ }
}

export function hasAlbumSignup() {
  try { return localStorage.getItem(albumSignupKey) === 'signed-up' || sessionSignup; }
  catch { return sessionSignup; }
}

export function rememberAlbumSignup(details?: AlbumSignupDetails) {
  if (details) {
    sessionDetails = JSON.stringify(details);
    try { localStorage.setItem(albumSignupDetailsKey, sessionDetails); sessionDetails = null; } catch { /* Keep it in this session. */ }
    rememberContributorName(details.name);
  }
  try { localStorage.setItem(albumSignupKey, 'signed-up'); }
  catch { sessionSignup = true; }
  window.dispatchEvent(new Event(changed));
}

export function subscribeAlbumSignup(notify: () => void) {
  const storageChanged = (event: StorageEvent) => {
    if (event.key === albumSignupDetailsKey || event.key === null) sessionDetails = null;
    if (event.key === albumSignupKey || event.key === albumSignupDetailsKey || event.key === null) notify();
  };
  window.addEventListener(changed, notify);
  window.addEventListener('storage', storageChanged);
  return () => {
    window.removeEventListener(changed, notify);
    window.removeEventListener('storage', storageChanged);
  };
}
